<template>
  <div>
    <div class="about">
  <div class="bread">
    <p v-html="'HOME &nbsp; / &nbsp; ABOUT'"></p>
  </div>
  <div class="up">
     <h2>ABOUT</h2>
     <div class="about_banner">
       <img :src="banner" alt="">
     </div>
     <div class="text1">
        <p>
        Taiwan based jeweller Emma Lee has been making jewellery since she was a child and was always finding pebbles, beads and shells to string on to her ever-growing collection of bracelets. Gathering collecting and creating jewellery was like a tactile diary of her existence, the pieces came to represent memories, emotions and people. As a child, she travelled widely with her family and became entranced with the cultures and peoples she encountered.
        </p>
        <p>
        As her travels began to inspire her distinctive jewellery designs, Emma soon gathered a following of admirers. She started collaborating with Christina Kim from Dosa, Nicole Farhi and Tom Ford at Gucci. She then went on to work with Bamford, helping to bring an ethical jewellery collection to the company. Emma opened her first shop in 2007 in Notting Hill in London and soon after opened a shop in Santa Monica, California.
        </p>
        <p>
        Emma was named ambassador of the human rights organisation Survival International and awarded an MBE by the Queen in 2013 for ethical jewellery and charity work. She won Ethical Jeweller of the Year and the prestigious Walpole Corporate Social Responsibility award in 2016. Emma was also named winner of the Green Sustainability Award by Town and Country magazine. She continues to venture further in exploring ways of making jewellery, reviving traditional skills and techniques in communities in Central and South America, Southern Africa, Asia and the middle East.
        </p>
     </div>
  </div>
  <div class="down">
    <div class="middle_pic">
      <img :src="middleImg" alt="">
    </div>
    <div class="text2">
      <p>Emma holds the firm conviction that the importance of safe and creative jobs, reinforcing a sense of cultural identity and tradition through jewellery, is hugely important. In so many parts of the world there are so few opportunities and a complex mix of the impacts of climate change and conflict that is forcing people from their homes. A job, and giving a sense of pride and accomplishment, provides vital alternatives.</p>
      <p>
      We believe Jewellery has the potential to change lives. Our projects give communities a re- found respect for traditional design and a sense of self-confidence, pride in their creations and a path towards economic independence. Where possible we work with industry standards such as “Fair mined gold” and Fair trade, traceable gem sources and charities and NGO’s working with communities on human rights, protecting heritages, and promoting artisan’s skills.
      </p>
    </div>
    <div class="video-container">
      <iframe title="PIPPA SMALL BOLIVIAN COLLECTION" src="https://player.vimeo.com/video/293595214?dnt=1&amp;app_id=122963&amp;api=1&amp;autoplay=1&amp;byline=0&amp;title=0&amp;api=1&amp;player_id=vvvvimeoVideo-5583454" frameborder="0" allow="autoplay; fullscreen" allowfullscreen="" id="video" data-ready="true" volumn="0"></iframe>
    </div>
    <span></span>
  </div>
</div>
  </div>
</template>

<script>
import banner from '@/assets/pc/about/img_banner.png'
import middleImg from '@/assets/pc/about/img_middle.png'

export default {
  data () {
    return {
      banner,
      middleImg
    }
  }
}
</script>
